import React, {  Component } from "react";
import { Link } from "react-router-dom";
import { FaAlignRight } from "react-icons/fa";
import logo from "../images/logo.svg";
//import {AuthContext } from "../context/auth";


export default class Navbar extends Component {
  // const  Navbar  = () => {
 // const{ user, logout} = useContext(AuthContext);
 
  state = {
    isOpen: false
  };
  handleToggle = () => {
    this.setState({ isOpen: !this.state.isOpen });
  };
 
  render() {
    return (
      <nav className="navbar">
        <div className="nav-center">
          <div className="nav-header">
            <Link to="/">
              <img src={logo} alt="Beach Resort" />
            </Link>
            <button
              type="button"
              className="nav-btn"
              onClick={this.handleToggle}
            >
              <FaAlignRight className="nav-icon" />
            </button>
          </div>
          <ul
            className={this.state.isOpen ? "nav-links show-nav" : "nav-links"}
          >
            <li>
              <Link to="/">Home</Link>
            </li>
            <li>
              <Link to="/rooms">Studios</Link>
            </li>
             <li>
              <Link to="/pricing">Pricing</Link>
            </li>
              <li>
              <Link to="/blog">Blog</Link>
            </li>
             <li>
              <Link to="/login">Login</Link>
            </li>
             <li> 
             <Link to="/pricing" className="btn-primary"> <small> Add Studio</small></Link>
            </li>
           
          </ul>
        </div>
      </nav>
    );
  }
}
